import { useQuery } from '@tanstack/react-query';
import { userService } from '@/services/userService';

const normalizeUserResponse = (response) => {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.teams)) return response.teams;
  if (Array.isArray(response.employees)) return response.employees;
  if (Array.isArray(response.users)) return response.users;
  return [];
};

export const useUsers = (params = {}) => {
  const query = useQuery({
    queryKey: ['users', params],
    queryFn: async () => {
      const response = await userService.getUsers(params);
      return normalizeUserResponse(response);
    },
    keepPreviousData: true,
  });

  return {
    teamMembers: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
